import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";

import App from "./app/app";
import { rootElementId } from "core/constants";

const root = ReactDOM.createRoot(
  document.getElementById(rootElementId) as HTMLElement
);

root.render(
  <StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </StrictMode>
);
